import { Button } from '@/cn/ui/button'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/cn/ui/tabs'
import { CHAIN_ID, NETWORKS } from '@/constants'
import { IUser, OrderType } from '@/interface'
import { popup } from '@/popup_handler'
import { useAppStore } from '@/store'
import { TitleBar } from '@/ui/titlebar'
import { ACTIVE_CURRENCY, queryClient, WALLET } from '@/utils'
import { useMutation } from '@tanstack/react-query'
import { CircleCheckBig } from 'lucide-react'
import { useState } from 'react'
import GiftCards from './gift-card'
import { base, polygon } from 'viem/chains'

const GiftCardHome = () => {
  const { wallet } = useAppStore((state: any) => state) as any
  const user = queryClient.getQueryData(['user']) as IUser
  const [currentChain] = useState(Object.values(NETWORKS).find((_) => _.chainId === user?.default_chain))
  const fromChain = currentChain?.chainId as CHAIN_ID

  const [tab, setTab] = useState('home')
  const [amount, setAmount] = useState('')
  const mutation = useMutation(
    async () => {
      const destinationChain = fromChain === polygon.id ? base.id : polygon.id
      /** current direct transfer is not compatible with gift architecture, so we are transfering gift to crosschain that does't use dirctTransfer */
      return WALLET.Send({
        wallet,
        to: wallet.address,
        value: String(Number(amount) / ACTIVE_CURRENCY.conversion_rate),
        sourceChain: fromChain,
        destinationChain: destinationChain,
        remark: '',
        orderType: OrderType.GIFT,
      })
    },
    {
      onError: (error: any) => {
        popup.open('error', {
          description: String(error.message || error),
        })
      },
      onSuccess: () => {
        setTab('home')
        popup.open('information', {
          icon: CircleCheckBig,
          iconClass: 'text-green-500',
          title: 'Gift Card Created',
          description: 'Gift Card Created Successfully',
        })
      },
    }
  ) as any

  return (
    <div className="flex flex-col gap-6 p-4 text-foreground w-full h-full">
      <TitleBar title="" />
      <Tabs onValueChange={setTab} value={tab} className="flex flex-col h-full">
        <div className="flex justify-center">
          <TabsList>
            <TabsTrigger value="home">My Gift Cards</TabsTrigger>
            <TabsTrigger value="buy-giftcards">Buy Gift Card</TabsTrigger>
          </TabsList>
        </div>
        <TabsContent value="home" className="flex-grow overflow-scroll">
          <GiftCards />
        </TabsContent>
        <TabsContent value="buy-giftcards">
          <div className="h-full w-full flex flex-col gap-8">
            <p className="text-center">Enter Amount</p>
            <label className="w-full flex items-center justify-center">
              <div className="flex gap-2 items-center text-4xl">
                {ACTIVE_CURRENCY.symbol}
                <input
                  type="number"
                  inputMode="decimal"
                  onChange={(e) => {
                    if ((e.target.value?.split('.')?.at(1)?.length || 0) <= 2) {
                      e.target.style.width = (e.target.value.length + 1) * 20 + 'px'
                      setAmount(e.target.value)
                    }
                  }}
                  value={amount !== undefined ? amount : ''}
                  className="outline-none w-6"
                  placeholder="0"
                  autoFocus
                  style={{
                    width: (amount.length + 1) * 20 + 'px',
                  }}
                />
              </div>
            </label>
            <Button loading={mutation.isLoading} onClick={() => mutation.mutate()}>
              Buy
            </Button>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  )
}
export default GiftCardHome
